<template>
    <figure>
        <v-chart :options="pie" class="cischart" auto-resize/>
    </figure>
</template>
<script>
import 'echarts/lib/chart/pie'
export default {
  name: 'cisPie',
  props: ['title', 'legendList', 'seriesData', 'seriesName'],
  data() {
    return {
      pie: {
        title: {
          text: this.title,
          x: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: this.legendList
        },
        series: [
          {
            name: this.seriesName,
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['50%', '60%'],
            data: this.seriesData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
  },
  watch: {
    title(n, o) {
      this.pie.title.text = n
    },
    legendList(n, o) {
      this.pie.legend.data = n
    },
    seriesName(n, o) {
      this.pie.series[0].name = n
    },
    seriesData(n, o) {
      this.pie.series[0].data = n
    }
  }
}
</script>
